import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import customBaseTheme from 'modules/theme/customBaseTheme';

import {containers as AuthContainers} from '../modules/auth';
import {containers as BaseContainers} from '../modules/core';
import {containers as LandingContainer} from '../modules/landing';
import EmailConfirmContainer from '../modules/blocks/EmailConfirmation';

import NotFound from 'modules/blocks/404'
import EmailConfirmation from 'modules/blocks/EmailConfirmation';

import AboutUs from 'modules/informations/AboutUs';
import ContactUs from 'modules/informations/ContactUs';
import MailingList from 'modules/informations/MailingList';

import TermsOfService from 'modules/informations/TermsOfService';
import PrivacyPolicy from 'modules/informations/PrivacyPolicy';
import CookiesPolicy from 'modules/informations/CookiesPolicy';

const {
  SignUpForm,
  SignInForm,
  ResetFormEmail,
  ResetFormPassword
} = AuthContainers;

const {
  Header,
  Footer
} = BaseContainers;

const {
  Landing
} = LandingContainer;


export default class extends Component {
  render() {
    return (
    <MuiThemeProvider muiTheme={getMuiTheme(customBaseTheme)} key={3}>
      <div className="public-wrap main-wrap">
        <Header />
        <Switch>
          <Route path="/signUp" component={SignUpForm} />
          <Route path="/signIn" component={SignInForm} />
          <Route path="/resetFormEmail" component={ResetFormEmail} />
          <Route path="/emailConfirm" component={EmailConfirmContainer} />
          <Route path="/resetFormPassword/token=:token" component={ResetFormPassword} />
          <Route path="/notfound" component={NotFound} />
          <Route path="/about-us" component={AboutUs} />
          <Route path="/contact-us" component={ContactUs} />
          <Route path="/terms-of-service" component={TermsOfService} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/cookies-policy" component={CookiesPolicy} />
          <Route path="/mailing-list" component={MailingList} />
          <Route path="/emailsent/:email" component={EmailConfirmation} />
          <Route path="/" component={Landing} exact />
          <Redirect to="/notfound"/>
        </Switch>
        <Footer />
      </div>
    </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/public.js